import React, { createContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { verifyLogin, getToken } from "../utilities/authHelper";
import DashboardSkeleton from "./DashboardSkeleton";
import { createTabs } from "./Sidebar/SidebarUtils";


export const fetchUserData = async (setLoading, setUserProfile, setError) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    setLoading(true);
    const response = await fetch(`${apiUrl}/auth:current`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setUserProfile(data.results);
  } catch (error) {
    console.error("Error fetching user data:", error);
    setError(true);
  } finally {
    setLoading(false);
  }
};
export const UserDashboardContext = createContext();

const ProtectedRoute = ({ children ,setTabs,tabs }) => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const location = useLocation();
  const isAuthenticated = verifyLogin();

  useEffect(() => {
    if (isAuthenticated) {
      fetchUserData(setLoading, setUserProfile, setError);
    }
    if (!isDataLoaded) {
      createTabs(setTabs);
      setIsDataLoaded(true);
    }
  }, [isAuthenticated]);

  if (loading) {
    return <DashboardSkeleton />;
  }

  if (!isAuthenticated || error) {
    return <Navigate to="/logout" state={{ from: location }} replace />;
  }

  return (
    <UserDashboardContext.Provider value={{ tabs }}>
      {children}
    </UserDashboardContext.Provider>
  );
};

export default ProtectedRoute;
